export default {
    baseStyle: {
        container: {},
        defaultLabel: {
            textStyle: 'badge',
            mb: 2
        },
        defaultLabelBorder: {
            display: 'inline-block',
            p: 1,
            border: '1px solid',
            borderColor: 'webTheme.strokeDefault'
        },
        addressLabel: {
            textStyle: 'badge',
        },
        name: {
            fontSize: 'sm',
            lineHeight: '18px'
        },
        addressLine: {
            fontSize: 'sm',
            lineHeight: '18px'
        }
    },
    variants: {
        orderReview: {
            name: {
                // textStyle: 'bodyXsSRegular',
                fontSize: {base: '12px', md: '14px'},
                lineHeight: {base: '16px', md: '20px'},
                fontWeight: '400'
            },
            addressLine: {
                // textStyle: 'bodyXsSRegular',
                fontSize: {base: '12px', md: '14px'},
                lineHeight: {base: '16px', md: '20px'},
                fontWeight: '400'
            }
        }
    }
}
